import(/* webpackMode: "eager", webpackExports: ["Progress"] */ "/app/components/ui/progress.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/ui/trend-chart.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
